import Cookies from "js-cookie";

const BASE_URL = "https://apiamburan.caspianentertainment.com/api";

const getLocale = async () => {
  if (typeof window !== "undefined") {
    return Cookies.get("NEXT_LOCALE") || "az";
  } else {
    const { headers } = await import("next/headers");
    const requestHeaders = await headers();
    const cookieHeader = requestHeaders.get("cookie") || "";
    const match = cookieHeader.match(/NEXT_LOCALE=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : "az";
  }
};

const http = async (url, options = {}) => {
  const locale = await getLocale();

  // 1️⃣ Content-Type YOXDUR → browser özü təyin edəcək
  const headers = {
    lang: locale,
    ...(options.headers || {}),
  };

  // 2️⃣ method default GET deyil → options.method üstünlük alır
  const requestOptions = {
    method: options.method || "GET",
    body: options.body || null,
    headers,
  };

  const res = await fetch(`${BASE_URL}/${url}`, requestOptions);

  if (!res.ok) {
    const errorMessage = `Error ${res.status}: ${res.statusText}`;
    throw new Error(errorMessage);
  }

  return res.json();
};

export default http;
